module.exports = __webpack_public_path__ + "img/thumbnail_Ocelot_m_leucistic.a3cdb3f2.png";